import { render, staticRenderFns } from "./CMPage.vue?vue&type=template&id=172762ee&lang=pug"
import script from "./CMPage.vue?vue&type=script&lang=js"
export * from "./CMPage.vue?vue&type=script&lang=js"
import style0 from "./CMPage.vue?vue&type=style&index=0&id=172762ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports